import {Form, Formik} from "formik";
import ScrollableTabs from "../Tabs";
import LoaderButton from "../LoaderButton";
import SaveIcon from "@mui/icons-material/Save";
import BugReportIcon from "@mui/icons-material/BugReport";
import ErrorIcon from "@mui/icons-material/Error";
import {Button, Grid} from "@mui/material";
import {BasicsDefaults, BasicsValidation} from "./Basics";
import {GeneralInfoDefaults, GeneralInfoValidation} from "./GeneralInfo";
/*
import {Debug} from "../Debug";
*/
import {LivingRoomDefaults} from "./LivingRoom";
import {KitchenDefaults} from "./Kitchen";
import {BathroomDefaults} from "./Bathroom";
import {OtherRoomsDefaults} from "./OtherRooms";
import {SecondaryRoomsDefaults} from "./SecondaryRooms";
import {BuildingExteriorDefaults} from "./BuildingExterior";
import {HeatingAndPlumbingDefaults} from "./HeatingAndPlumbing";
import {HealthAndSafetyDefaults} from "./HealthAndSafety";
import {OptionalsDefaults} from "./Optionals";

const validationSchema = () => {
    return BasicsValidation().concat(GeneralInfoValidation());
}

const initialValues = () => {
    return {
        ...BasicsDefaults(),
        ...GeneralInfoDefaults(),
        ...LivingRoomDefaults(),
        ...KitchenDefaults(),
        ...BathroomDefaults(),
        ...OtherRoomsDefaults(),
        ...SecondaryRoomsDefaults(),
        ...BuildingExteriorDefaults(),
        ...HeatingAndPlumbingDefaults(),
        ...HealthAndSafetyDefaults(),
        ...OptionalsDefaults(),
    };
}

const HqsForm = (initialValues, onSubmit, deleteButton) => {
    return (
        <>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={validationSchema()}
                onSubmit={onSubmit}
                children={(props) => (
                    <Form>
                        <ScrollableTabs/>
                        <Grid container
                              spacing={3}
                              direction={"row"}
                        >
                            <Grid item>
                                <LoaderButton
                                    variant="contained"
                                    color="primary"
                                    size={"medium"}
                                    startIcon={<SaveIcon/>}
                                    /*
                                                                        disabled={!props.isValid}
                                    */
                                    isLoading={props.isSubmitting}
                                    type={"submit"}
                                >
                                    {"Save"}
                                </LoaderButton>
                            </Grid>
                            <Grid item>
                                {!!deleteButton ? deleteButton() : null}
                            </Grid>
                            <Grid item>
                                <Button
                                    variant={"contained"}
                                    color={"secondary"}
                                    startIcon={<BugReportIcon/>}
                                    onClick={() => {
                                        navigator.clipboard.writeText(JSON.stringify(props, null, 2))
                                            .then(r => (alert("Copied to clipboard"))).catch((err) => (alert(err)));
                                    }}
                                >Copy Debug Info</Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant={"contained"}
                                    color={"secondary"}
                                    startIcon={<ErrorIcon/>}
                                    disabled={props.isValid}
                                    onClick={() => {
                                        alert(JSON.stringify(props.errors, null, 2));
                                    }}
                                >
                                    {"Show Errors"}
                                </Button>
                            </Grid>
                        </Grid>

{/*
                        <Debug/>
*/}

                    </Form>
                )}
            />
        </>
    );
}

export default HqsForm;
export {initialValues};